import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const orig = error.config;
    if (error.response?.status === 401 && !orig._retry && !orig.url.includes("/auth/")) {
      orig._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(orig);
      } catch (e) {
        refreshing = null;
        window.dispatchEvent(new Event("auth:logout"));
      }
    }
    return Promise.reject(error);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Algo deu errado. Tente novamente.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  return String(d);
}

export const brl = (v) => (v == null || v === "" ? "—" : Number(v).toLocaleString("pt-BR", { style: "currency", currency: "BRL" }));
export const dt = (v) => (v ? new Date(v).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—");
export const dOnly = (v) => (v ? new Date(v.length === 10 ? v + "T12:00:00" : v).toLocaleDateString("pt-BR") : "—");
export const fileUrl = (id) => (id ? `${API}/files/${id}` : null);
export const publicMedia = (id) => (id ? `${API}/public/media/${id}` : null);

export const LEAD_STATUS = {
  novo: "Novo", em_qualificacao: "Em qualificação", qualificado: "Qualificado", interessado: "Interessado",
  visita_solicitada: "Visita solicitada", visita_agendada: "Visita agendada", em_negociacao: "Em negociação", convertido: "Convertido", perdido: "Perdido",
};
export const CONV_STATE = { AI_ACTIVE: "IA atendendo", WAITING_HUMAN: "Aguardando atendente", HUMAN_ACTIVE: "Atendimento humano", CLOSED: "Encerrado" };
export const PROP_STATUS = { disponivel: "Disponível", reservado: "Reservado", vendido: "Vendido", alugado: "Alugado", inativo: "Inativo" };
export const PROP_TYPES = { casa: "Casa", apartamento: "Apartamento", lote: "Lote", fazenda: "Fazenda", sala_comercial: "Sala comercial", outros: "Outros" };
export const ROLE_LABEL = { superadmin: "Superadmin", admin: "Administrador", manager: "Gerente", broker: "Corretor" };
export const HANDOFF_REASON = { cliente_pediu: "Cliente pediu", negociacao: "Negociação", visita: "Visita", questao_complexa: "Questão complexa", sem_informacao: "Sem informação", falha_ia: "Falha da IA", regra: "Regra configurada", manual: "Comando manual" };
export const VISIT_STATUS = { solicitada: "Solicitada", agendada: "Agendada", confirmada: "Confirmada", remarcada: "Remarcada", cancelada: "Cancelada", concluida: "Concluída" };

export async function download(path, filename) {
  const r = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
